<template>
  <div class="home-div">
    <SideBar />
    <div class="mid">
      <div class="login-con">
      <div class="input-group">
        <label class="input-label">邮箱：</label>
        <input type="text" class="input-style bgc" v-model="email" placeholder="请输入邮箱" required />
      </div>
      <div class="input-group">
        <label class="input-label">密码：</label>
        <input type="password" class="input-style bgc" v-model="pwd" placeholder="请输入密码" required />
      </div>
      <div class="button-group">
        <button class="btn-login" @click="handleLogin">登录</button>
      </div>
    </div>
    </div>
    <BottomTip style="position: fixed; bottom: 0; z-index: 100" />
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { Message } from 'element-ui';

import { userLogin } from '@/api/login';
import DataAuth from '@/utils/DataAuth';
import CookieUtil from '@/utils/CookieUtil';
import config from '@/utils/Config';
import router from '@/router';

export default {
  name: 'Login',
  components: {
    SideBar,
    BottomTip,
  },
  data() {
    return {
      email: '',
      pwd: '',
      gDkey: '87974c41247ff5cc3cbad3ecd3de4706',
      weather: {},
      iconCondition: null,
    };
  },
  created() {
    this.email == '';
    this.pwd == '';
  },
  mounted() {
    this.getUserPositionInfo();
  },
  methods: {
    async getUserPositionInfo() {
      // return get('https://restapi.amap.com', '/v3/ip', {
      //   key: this.key,
      // }).then(res => {
      //   // console.log('--->', res);
      // });
    },
    handleLogin() {
      // 数据校验
      if(!DataAuth.validateEmail(this.email)){
        Message.error('邮箱填写错误！');
        return;
      }
      if(!DataAuth.validatePassword(this.pwd)){
        Message.error('密码填写错误！');
        return;
      }
      this.userLoginMethod();
    },

    async userLoginMethod(){
      const resp = await userLogin({email: this.email, pwd: this.pwd});
      const tokenFlag = CookieUtil.set(config.TOKEN_KEY, resp.data.token, 1);
      const userInfoFlag = CookieUtil.set(config.USER_INFO_KEY, JSON.stringify(resp.data.userInfo), 1);
      if(tokenFlag && userInfoFlag){
        router.push('/admin');
        return;
      }
      Message.error('用户登录失败！');
    }
  },
};
</script>

<style scoped>
.home-div {
  width: 100%;
  height: calc(100vh - 100px);
  margin: 0;
  padding-top: 100px;
}
.mid{
  display: flex;
  flex-direction: column;
  align-items: center; 
}

.login-con {
  width: 26%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-size: 20px;
  color: #FFFFFF;
  z-index: 999;
}

.input-group {
  width: 100%;
  margin-bottom: 20px;
}

.input-label {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
}

.input-style {
  width: 100%;
  padding: 12px 0 20px 0;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
}

.input-style:focus {
  border-color: #66afe9;
}

.input-style::placeholder {
  color: #b1b0b0;
  /* font-style: italic; */
}

/* .input-style:focus::placeholder {
  color: transparent;
} */

.button-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 10px;
}

.bgc{
    background-color: rgba(255, 255, 255, 0.2);
    color: #FFFFFF;
}

.btn-login,
.btn-reset {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 40px;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.btn-login {
  background-color: #4caf50; /* 深绿色 */
}

.btn-login:hover {
  background-color: #45a049; /* 深绿色变亮 */
}

@media only screen and (max-width: 768px) {
  .login-con {
  width: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-size: 20px;
  margin-top: 100px;
}
}

</style>